import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";
import { Observable } from "rxjs";

// /core2/tnt/dm/erp/gen-doc/order-received-outstanding-qty-amount/backoffice-ep/{guid}

@Injectable({ providedIn: "root" })
export class GenDocOrderReceivedOutstandingAmountService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + "order-received-outstanding-qty-amount/backoffice-ep";
    this.httpClient = http;
  }

  public getAmount(dtoObject: any, visa: ApiVisa, guid: string){
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl + '/' + guid,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


}
